export default class ChamadoCalendar {
    constructor(resource) {
        this._resource = resource('chamadoscalendario_supo');
    }

    get() {
        return this._resource
            .get()
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }
}